import styled from "styled-components";

export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${props => props.theme.white1};
  align-items: center;
  height: 100vh;
`;

export const ContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  margin-left: 10px;
`;
export const TitleContainer = styled.div`
  max-width: 1540px;
  height: 110px;
  margin: 20px 0px 0 0;
  padding: 12px 20px;
  background-color: ${props => props.theme.white0};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid ${props => props.theme.white5};
  position: relative;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  @media (max-width: 1440px) {
    min-width: 760px;
  }
  span {
    margin: 0 40px;
    text-align: center;
  }
  span p {
    color: ${props => props.theme.black2};
  }
  div{
    margin: 0 20px;
    width: 1px;
    height: 100%;
    background-color: ${props => props.theme.black1};
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: scroll;
  @media (max-width: 1440px) {
    flex-direction: column;
  }
`;
export const FlexContainerTitle = styled.div`
  max-width: 1540px;
  margin: 10px 0px 0 0;
  padding: 12px 20px;
  background-color: ${props => props.theme.white0};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid ${props => props.theme.white5};
  position: relative;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  @media (max-width: 1440px) {
    min-width: 760px;
  }
`;

export const ValueContainerBox = styled.div`
  display: flex;
  @media (max-width: 1440px) {
    display: block;
    align-items: center;
  }
`;
export const ValueContainerTitle = styled.div`
  max-width: 760px;
  padding: 12px 20px;
  margin: 10px 20px 0 0;
  background-color: ${props => props.theme.white0};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid ${props => props.theme.white5};
  position: relative;
  border-radius: 7px;
  display: flex;
    flex-direction: column;
    align-items: center;
hr {
  width: calc(100% - 20px);
  margin: 10px;
}
  @media (max-width: 1440px) {
    min-width: 760px;
  }
`;
export const ValueContainerLine = styled.div`
  width: 760px;
  max-width: 760px;
  height: 70px;
  display: flex;
  padding: 12px 20px;
  position: relative;
  align-items: center;
  justify-content: space-evenly;
  nav{
    margin: 0 10px;
    height: 100%;
    width: 1px;
    background-color: ${props => props.theme.black2};;
  }
  @media (max-width: 1440px) {
    width: auto;
  }
`;
export const ValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  span {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  p {
    font-size: 14px;
    color: ${props => props.theme.black2};
  }
  h4 {
    margin: 0 10px 0 10px;
    font-weight: 600;
  }
  span p {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
  }
`;
export const ChartContainerLine = styled.div`
  display: flex;
  @media (max-width: 1440px) {
    display: block;
  }
`;
export const ChartContainer = styled.div`
  overflow: hidden;
  padding: 10px;
  position: relative;
  width: 760px;
  height: 440px;
  p{
    position: fixed;
    margin: 0;
  }
  @media (max-width: 1440px) {
    width: auto;
    max-width: 750px;
  }
`;

export const InfoContainerLine = styled.div`
  display: grid;
  grid-template-columns: 260px 260px;
  grid-template-rows: 120px;
  max-width: 520px;
`;

export const InfoContainer = styled.div`
  width: 240px;
  height: 100px;
  margin: 20px 20px 0 0;
  padding: 15px 20px;
  background-color: ${props => props.theme.white0};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid ${props => props.theme.white5};
  position: relative;
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
